/* Texto do assistente → blocos para a tela, sem HTML: o que vem do modelo
   nunca vira markup. Entende só o pouco que as respostas usam: parágrafos,
   listas (“- ”, “• ”, “1. ”), **negrito** e links internos [texto](/caminho),
   que viram botões para a tela. Link externo fica como texto. */

const INTERNAL = /^\/(?!\/)[\w\-/?=&.%]*$/;

// "Veja [Relatórios](/reports/queries) e **PDF**" → partes
export const parseInline = (text) => {
  const parts = [];
  const pattern = /\*\*([^*]+)\*\*|\[([^\]]+)\]\(([^)\s]+)\)/g;
  let last = 0;
  let match;
  const source = String(text || "");
  while ((match = pattern.exec(source))) {
    if (match.index > last)
      parts.push({ type: "text", text: source.slice(last, match.index) });
    if (match[1] != null) parts.push({ type: "bold", text: match[1] });
    else if (INTERNAL.test(match[3]))
      parts.push({ type: "link", text: match[2], to: match[3] });
    else parts.push({ type: "text", text: match[2] });
    last = pattern.lastIndex;
  }
  if (last < source.length)
    parts.push({ type: "text", text: source.slice(last) });
  return parts;
};

const LIST_ITEM = /^\s*(?:[-•*]|\d+[.)])\s+(.*)$/;

export const parseBlocks = (text) => {
  const blocks = [];
  String(text || "")
    .replace(/\r/g, "")
    .split("\n")
    .forEach((line) => {
      const item = line.match(LIST_ITEM);
      const last = blocks[blocks.length - 1];
      if (item) {
        if (last?.type === "list") last.items.push(parseInline(item[1]));
        else blocks.push({ type: "list", items: [parseInline(item[1])] });
      } else if (/^\s+\S/.test(line) && last?.type === "list") {
        // linha recuada logo abaixo de um item continua o item
        const current = last.items[last.items.length - 1];
        current.push({ type: "break" }, ...parseInline(line.trim()));
      } else if (line.trim() === "") {
        if (last && last.type !== "gap") blocks.push({ type: "gap" });
      } else if (last?.type === "paragraph") {
        last.lines.push(parseInline(line.trim()));
      } else {
        blocks.push({ type: "paragraph", lines: [parseInline(line.trim())] });
      }
    });
  return blocks.filter((block) => block.type !== "gap");
};

// Telas citadas na resposta, sem repetir — viram os botões "Ir para".
export const collectLinks = (blocks) => {
  const seen = new Map();
  const visit = (parts) =>
    parts.forEach((part) => {
      if (part.type === "link" && !seen.has(part.to)) seen.set(part.to, part);
    });
  (blocks || []).forEach((block) => {
    if (block.type === "list") block.items.forEach(visit);
    else block.lines.forEach(visit);
  });
  return [...seen.values()];
};

// "Relatórios › Consultas" → ["Relatórios", "Consultas"]
export const crumbsOf = (text) =>
  String(text || "")
    .split(/\s*[›>/]\s*/)
    .map((part) => part.trim())
    .filter(Boolean);
